import { localize } from "utils/localizer";

const i18n = {
    accept: {
        en: (price: string) => `Accept ${price ? ` (${price})` : ""}`,
        de: (price: string) => `Annehmen ${price ? ` (${price})` : ""}`,
    },
    acceptRequest: {
        en: "Accept request",
        de: "Anfrage annehmen",
    },
    addException: {
        en: "Add exception",
        de: "Ausnahme hinzufügen",
    },
    addMedia: {
        en: "Add Media",
        de: "Medien hinzufügen",
    },
    advanced: {
        en: "Advanced",
        de: "Erweitert",
    },
    allDay: {
        en: "All-day",
        de: "Ganztägig",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    answerInvitationSuccess: {
        en: (accept: boolean) => `Invitation successfully ${accept ? "accepted" : "declined"}`,
        de: (accept: boolean) => `Einladung erfolgreich ${accept ? "angenommen" : "abgelehnt"}`,
    },
    answerRequestSuccess: {
        en: (accept: boolean) => `Request successfully ${accept ? "accepted" : "declined"}`,
        de: (accept: boolean) => `Anfrage erfolgreich ${accept ? "angenommen" : "abgelehnt"}`,
    },
    blockedFor: {
        en: "Blocked for",
        de: "Gesperrt für",
    },
    blockingBlueprints: {
        en: {
            "external-blocking": "Externals",
            "court-blocking": "All",
            "demographic-blocking": "Specific",
        },
        de: {
            "external-blocking": "Externe",
            "court-blocking": "Alle",
            "demographic-blocking": "Bestimmte",
        },
    },
    book: {
        en: (price: string) => `Book ${price ? ` (${price})` : ""}`,
        de: (price: string) => `Buchen ${price ? ` (${price})` : ""}`,
    },
    bookingTypes: {
        en: {
            blocking: "Blocking",
            meetup: "Meetup",
            standard: "Booking",
            training: "Event",
        },
        de: {
            blocking: "Sperrung",
            meetup: "Treffen",
            standard: "Buchung",
            training: "Event",
        },
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    cancelRepeatedBooking: {
        en: "Cancel Repeated Booking",
        de: "Wiederkehrende Buchung absagen",
    },
    cancelB: {
        en: "Cancel",
        de: "Absagen",
    },
    cancelBooking: {
        en: "Cancel Booking",
        de: "Buchung absagen",
    },
    cancelParticipationRequest: {
        en: "Cancel request",
        de: "Anfrage zurückziehen",
    },
    cancelParticipationRequestSuccess: {
        en: "Participation request cancelled",
        de: "Teilnahmeanfrage zurückgezogen",
    },
    cancellationReason: {
        en: "Cancellation reason",
        de: "Absagegrund",
    },
    cancellationReasonLength: {
        en: "Between 4 and 100 characters",
        de: "Zwischen 4 und 100 Buchstaben",
    },
    checkIn: {
        en: "Check-in",
        de: "Einchecken",
    },
    checkInSuccess: {
        en: "Successfully checked in",
        de: "Erfolgreich eingecheckt",
    },
    club: {
        en: "Location",
        de: "Sportstätte",
    },
    coronaTracing: {
        en: "Enable COVID-19 contact tracing for this booking",
        de: "COVID-19 Kontakterfassung für diese Buchung aktivieren",
    },
    court: {
        en: "Court",
        de: "Platz",
    },
    courtOccupied: {
        en: "Court occupied",
        de: "Platz belegt",
    },
    decline: {
        en: "Decline",
        de: "Ablehnen",
    },
    declineRequest: {
        en: "Decline request",
        de: "Anfrage ablehnen",
    },
    description: {
        en: "Description",
        de: "Beschreibung",
    },
    privateDescription: {
        en: "Private description",
        de: "Private Beschreibung",
    },
    moreInformation: {
        en: "More Information",
        de: "Mehr Informationen",
    },
    duration: {
        en: "Duration",
        de: "Dauer",
    },
    durationHint: {
        en: (rem: number, max: number) => `Remaining: ${rem} / ${max} min`,
        de: (rem: number, max: number) => `Verbleibend: ${rem} / ${max} min`,
    },
    edit: {
        en: "Edit",
        de: "Bearbeiten",
    },
    editBooking: {
        en: "Edit Booking",
        de: "Buchung bearbeiten",
    },
    editCustomMaxNumParticipants: {
        en: "If smaller than the number of participants no participants will be removed.",
        de: "Falls kleiner als die Anzahl Teilnehmer werden keine Teilnehmer entfernt.",
    },
    editCustomMinNumParticipants: {
        en: "If smaller than the number of participants the booking becomes final; if larger the booking will not be marked as pending.",
        de: "Falls kleiner als die Anzahl Teilnehmer wird die Buchung sofort final; falls größer wird die Buchung aber nicht als ausstehend markiert.",
    },
    editRootGroups: {
        en: "Edit Root Groups",
        de: "Root-Gruppen bearbeiten",
    },
    enterName: {
        en: "Enter name",
        de: "Name eingeben",
    },
    editRepeatedBooking: {
        en: "Edit Repeated Booking",
        de: "Wiederkehrende Buchung bearbeiten",
    },
    eventType: {
        en: "Event type",
        de: "Art des Events",
    },
    eventTypes: {
        en: {
            commercial: "Commercial",
            competition: "Competition",
            "video-stream": "Live Stream",
            standard: "Standard",
            "video-conference": "Video Conference",
        },
        de: {
            commercial: "Kommerziell",
            competition: "Competition",
            "video-stream": "Livestream",
            standard: "Standard",
            "video-conference": "Videokonferenz",
        },
    },
    finalizationDeadline: {
        en: "Participation deadline",
        de: "Zusagefrist",
    },
    finalizationDeadlineRepeatedWarn: {
        en: "For repetitions of this booking, the deadline will be adjusted to the match the time interval before the start of the booking accordingly.",
        de: "Für Wiederholungen dieser Buchung wird die Frist auf das gleiche Zeitintervall vor Beginn der Buchung entsprechend angepasst.",
    },
    followingMe: {
        en: "Following me",
        de: "Folgt mir",
    },
    fundsRecipient: {
        en: "Funds recipient",
        de: "Zahlungsempfänger",
    },
    fundsRecipientWarn: {
        en: "Attention: You cannot change who will receive payouts for this booking later.",
        de: "Achtung: Du kannst später nicht ändern, wer Zahlungen für diese Buchung ausbezahlt bekommt.",
    },
    hideCreator: {
        en: "Hide Creator",
        de: "Ersteller verstecken",
    },
    creatorMediaOnly: {
        en: "Creator Media Only",
        de: "Nur Creator-Medien",
    },
    inviteNewGroups: {
        en: "Invite new groups",
        de: "Neue Gruppen einladen",
    },
    leaveBooking: {
        en: "Leave Booking",
        de: "Teilnahme absagen",
    },
    leaveBookingPrice: {
        en: (price: string) => `Cancelling your participation in this booking ${price ? `costs ${price}.` : "is free. "}`,
        de: (price: string) => `Für das Absagen deiner Teilnahme an der Buchung fallen ${price || "keine"} Gebühren an. `,
    },
    leaveBookingBlocking: {
        en: "This cancels the blocking. ",
        de: "Die Sperrung wird hiermit aufgehoben. ",
    },
    leaveBookingDeclineWillCancel: {
        en: "This cancels the booking. ",
        de: "Die Buchung wird hiermit storniert. ",
    },
    maxNumParticipants: {
        en: "Max. participants",
        de: "Max. Mitspieler",
    },
    mediaComment: {
        en: "Media comment",
        de: "Kommentartext zu Medien",
    },
    minNumParticipants: {
        en: "Min. participants",
        de: "Min. Mitspieler",
    },
    newBooking: {
        en: "New Booking",
        de: "Neu buchen",
    },
    newParticipants: {
        en: "Invite more participants",
        de: "Weitere Mitspieler einladen",
    },
    organisationMembers: {
        en: "Invite organization members",
        de: "Laden Sie Organisationsmitglieder ein",
    },
    nextDay: {
        en: "Next Day",
        de: "Nächster Tag",
    },
    noParticipantsSelected: {
        en: "No participants selected",
        de: "Keine Mitspieler ausgewählt",
    },
    ok: {
        en: "Ok",
        de: "Ok",
    },
    opened: {
        en: "Opened",
        de: "Geöffnet",
    },
    participants: {
        en: "Participants",
        de: "Mitspieler",
    },
    tags: {
        en: "Tags",
        de: "Tags",
    },
    tagName: {
        en: "Enter tag",
        de: "Tag hinzufügen",
    },
    participate: {
        en: (price: string) => `Participate ${price ? ` (${price})` : ""}`,
        de: (price: string) => `Mitmachen ${price ? ` (${price})` : ""}`,
    },
    participationRequestSuccess: {
        en: "Participation requested",
        de: "Teilnahmeanfrage gestellt",
    },
    participationRequests: {
        en: "Participation requests",
        de: "Teilnahmeanfragen",
    },
    participationRequestType: {
        en: {
            "auto-accept": "Accept all",
            "auto-accept-for-group": "Accept specific",
            "invite-only": "Invite only",
            "requestable-by-followers": "Allow requests",
        },
        de: {
            "auto-accept": "Alle akzeptieren",
            "auto-accept-for-group": "Bestimmte akzeptieren",
            "invite-only": "Nur Einladungen",
            "requestable-by-followers": "Anfragen zulassen",
        },
    },
    participantSpecificCheckIn: {
        en: "Every participant must check-in",
        de: "Jeder Teilnehmer muss einchecken",
    },
    previousDay: {
        en: "Previous Day",
        de: "Vorheriger Tag",
    },
    removeInvitedGroups: {
        en: "Remove invited groups",
        de: "Eingeladene Gruppen entfernen",
    },
    removePendingParticipants: {
        en: "Remove pending participants",
        de: "Ausstehende Mitspieler entfernen",
    },
    repeat: {
        en: "Repeat",
        de: "Wiederholen",
    },
    repeatTypes: {
        en: {
            never: "Never",
            daily: "Daily",
            weekly: "Weekly",
            biweekly: "Every 2 weeks",
            monthly: "Monthly",
        },
        de: {
            never: "Niemals",
            daily: "Täglich",
            weekly: "Wöchentlich",
            biweekly: "Alle 2 Wochen",
            monthly: "Monatlich",
        },
    },
    repeatUntil: {
        en: "Repeat until",
        de: "Wiederholen bis",
    },
    requestCancellation: {
        en: "Request cancellation",
        de: "Absage erbitten",
    },
    reset: {
        en: "Reset",
        de: "Zurücksetzen",
    },
    save: {
        en: "Save",
        de: "Speichern",
    },
    sportForm: {
        en: "Sport form",
        de: "Sportart",
    },
    standardParticipationPriceCents: {
        en: "Participation fee",
        de: "Teilnahmegebühr",
    },
    standardParticipationPriceCentsWarn: {
        en: "Amount over 50€. Are you sure?",
        de: "Betrag über 50€. Bist du sicher?",
    },
    startDate: {
        en: "Start date",
        de: "Startzeit",
    },
    thisBooking: {
        en: "This booking",
        de: "Diese Buchung",
    },
    thisBookingAndFollowing: {
        en: "This booking and all following",
        de: "Diese Buchung und alle folgenden",
    },
    title: {
        en: "Title",
        de: "Titel",
    },
    titleLength: {
        en: "Between 4 and 40 characters",
        de: "Zwischen 4 und 40 Buchstaben",
    },
    useAsTemplate: {
        en: "Use as template",
        de: "Als Vorlage nutzen",
    },
    videoConferenceParticipantsNotice: {
        en: "Limited to 8 simultaneous participants",
        de: "Maximal 8 gleichzeitige Teilnehmer",
    },
    paywhatyouwant: {
        en: "Pay what you want",
        de: "Zahle was du willst",
    },
    bookingTags: {
        en: "Art (Booking-Tags)",
        de: "Buchungs-Tag",
    },
    virtualEvent: {
        en: {
            "video-stream": "Live-stream",
            "video-conference": "Video-Conference",
        },
        de: {
            "video-stream": "Livestream",
            "video-conference": "Videokonferenz",
        },
    },
    companyExclusive: {
        en: "Exclusive for organisations",
        de: "Exklusiv für Organisationen",
    },
    exclusiveTag: {
        en: "Exclusive",
        de: "Exklusiv",
    },
    sharedTag: {
        en: "Shared",
        de: "Geteilt",
    },
    allOrganizations: {
        en: "All organizations",
        de: "Alle Organisationen",
    },
    exclusiveCompanyPriceCentsLbl: {
        en: "Event Price",
        de: "Event-Preis",
    },
    exclusiveCompanyClubLbl: {
        en: "Company Exclusive Club",
        de: "Company Exclusive Club",
    },
    clubSite: {
        en: "Club Site",
        de: "Standort",
    },
    audienceSize: {
        en: (size: number) => `Audience (${size} users)`,
        de: (size: number) => `Zielgruppe (${size} Benutzer)`,
    },
    today: {
        en: "Today",
        de: "Heute",
    },
    yesterday: {
        en: "Yesterday",
        de: "Gestern",
    },
    andMore: {
        en: (num: number) => `and ${num} more`,
        de: (num: number) => `und ${num} weitere`,
    },
    noEventPlanned: {
        de: "Zur Zeit sind noch keine Veranstaltungen geplant.",
        en: "There are no events planned at this time.",
    },
    listViewTitle: {
        en: "Company events",
        de: "Geplante Firmenevents",
    },
    filter: {
        en: "Filter",
        de: "Filtern",
    },
    bookingsFrom: {
        en: "Bookings from",
        de: "Buchungen ab",
    },
    bookingQuery: {
        en: "Events search",
        de: "Veranstaltungssuche",
    },
    apply: {
        en: "Apply",
        de: "Anwenden",
    },
    isVirtualEvent: {
        en: "Virtual events",
        de: "Virtuelle Veranstaltungen",
    },
    details: {
        en: "Details",
        de: "Details",
    },
    cancelReasonMessage: {
        en: "Please enter a reason for cancellation with at least four letters.",
        de: "Bitte trage einen Absagegrund mit mindestens vier Buchstaben ein.",
    },
    bookingFilter: {
        en: {
            "company-shared": "Shared events for organisations",
            "company-exclusive": "Exclusive events for organisations",
            all: "All events for organisations",
        },
        de: {
            "company-shared": "Geteilte Events für Organisationen",
            "company-exclusive": "Exklusive Events für die Organisation",
            all: "Alle Events für Organisationen",
        },
    },
    noRecordFound: {
        en: "There is no event.",
        de: "Es gibt keine passenden Veranstaltungen.",
    },
    invalidOrForbiddenParticipantsError: {
        en: "One or more of the requested participants either do not exist or the user may not invite them. For example because they are no member of the organisation.",
        de: "Einer oder mehrere der angeforderten Teilnehmer existieren entweder nicht oder der Benutzer darf sie nicht einladen. Zum Beispiel, weil sie kein Mitglied der Organisation sind.",
    },
    editNotifyNumberOfDays: {
        en: "Edit notify number of days",
        de: "Bearbeiten Sie die Anzahl der Tage für die Benachrichtigung",
    },
    days: {
        en: "Days",
        de: "Tage",
    },
};

export default localize(i18n);
